// Formátování datumů a čísel — česky.

const dateFmt = new Intl.DateTimeFormat('cs-CZ', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('cs-CZ', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function fmtDate(ms: number | null | undefined): string {
  if (!ms) return '—';
  return dateFmt.format(new Date(ms));
}

export function fmtDateTime(ms: number | null | undefined): string {
  if (!ms) return '—';
  return dateTimeFmt.format(new Date(ms));
}

export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null) return '—';
  if (ms < 1000) return `${ms}ms`;
  const s = Math.round(ms / 100) / 10;
  return `${s.toFixed(1)}s`;
}

export function fmtNum(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString('cs-CZ');
}
